import React, { useEffect, useState } from "react";
import Files from "./FilesForPayment";

const Cases = ({ data }) => {

    return (
        
        <div className="flex mt-28 flex-col ">
            <div className="min-h-screen rounded-2xl w-full px-2 sm:px-4 py-12 bg-center  bg-no-repeat bg-cover" style={{ backgroundImage: `url('${data.bg}')`}}>
                <span className="text-white font-medium text-[48px] lg:text-5xl">{data.title}</span>
                <div className="w-full flex sm:flex-row flex-col gap-4 py-8 px-10">

                    {
                        data.card.slice(0,2).map((card,index) => (
                            <div key={index} className="w-full sm:w-[50%] h-[410px]  opacity-80 hover:opacity-100 transition-opacity duration-300 ease-linear bg-[#FFFFFF] p-4 rounded-xl cursor-pointer" onClick={() => window.location.replace(card.url_source)} 
                            style={{ 
                                backgroundImage: `url('${card.bg}')`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                            }}>
                                <div className="p-2 w-full flex flex-row h-full items-end">
                                    <div className="p-2 w-full flex justify-between items-center gap-[15px] rounded-xl bg-white">
                                        <div className="flex flex-col gap-2">
                                            <span className="font-medium lg:text-[28px] md:text-[24px] text-[18px] color-[#000000]">{card.desc}</span>
                                            <span className="color-[#000000]">{card.date}</span>
                                        </div>
                                        <img className="w-[34px] h-[34px]" src="iconCases.svg" alt="Arrow" /> 
                                    </div>
                                    
                                </div>
                            </div>
                        )) 
                    }

                    
                    
                </div>
            </div>

            <Files />
        </div>
    );
};

export default Cases;
